export enum PwdTypeEnum {
  PASSWORD = "password",
  TEXT = "text",
}
